module.exports = function getResource(label) {
    let resources = {
        saveToMyAccountCheckbox: 'Enregistrer dans mon compte'
    };

    return resources[label];
};
